const escape = (value: string) => {
  const escaped = value.replaceAll(/(?<!\\)(?:\\\\)*([{<])/g, '\\$1');

  return escaped;
};

export default escape;
